var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;opacity:0;}.cls-2{fill:#231f20;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-arrow-circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-arrow-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-arrow-circle-2",
    "data-name": "menu-arrow-circle"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24,
    transform: "translate(24 24) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,6A3.5,3.5,0,0,0,8.5,9.5a1,1,0,0,0,2,0A1.5,1.5,0,1,1,12,11a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V12.84A3.49,3.49,0,0,0,12,6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12,
    cy: 17,
    r: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.07b6060a2b8c6026176b0fc57a0a2afc.svg";
export { ForwardRef as ReactComponent };